import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './axios'
import './assets/styles/styles.scss'
import Maska from 'maska'
import components from './components/UI'
import directives from './directives'
const app = createApp(App)

components.forEach(component => {
  app.component(component.name, component)
})

directives.forEach(directive => {
  app.directive(directive.name, directive)
})

app
  .use(Maska)
  .use(store)
  .use(router)
  .mount('#app')

window.postMessage({ devtoolsEnabled: true, vueDetected: true })
